import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface InitialStateTypes {
    success: number | null,
    successShow: boolean,
    warning: number | null,
    warningShow: boolean,
    error: number | null,
    errorShow: boolean
}


let initialState: InitialStateTypes = {
    success: null,
    successShow: false,
    warning: null,
    warningShow: false,
    error: null,
    errorShow: false
}

export const responseInfoSlices = createSlice({
    name: 'responseInfo',
    initialState,
    reducers: {
        setSuccess(state, action: PayloadAction<number | null>) {
            state.success = action.payload
        },
        setSuccessShow(state, action: PayloadAction<boolean>) {
            state.successShow = action.payload
        },
        setWarning(state, action: PayloadAction<number | null>) {
            state.warning = action.payload
        },
        setWarningShow(state, action: PayloadAction<boolean>) {
            state.warningShow = action.payload
        },
        setError(state, action: PayloadAction<number | null>) {
            state.error = action.payload
        },
        setErrorShow(state, action: PayloadAction<boolean>) {
            state.errorShow = action.payload
        }
    },
})


export const setResponseSuccess = (success: number | null) => responseInfoSlices.actions.setSuccess(success)
export const setResponseSuccessShow = (successShow: boolean) => responseInfoSlices.actions.setSuccessShow(successShow)
export const setResponseWarning = (warning: number | null) => responseInfoSlices.actions.setWarning(warning)
export const setResponseWarningShow = (warningShow: boolean) => responseInfoSlices.actions.setWarningShow(warningShow)
export const setResponseError = (error: number | null) => responseInfoSlices.actions.setError(error)
export const setResponseErrorShow = (errorShow: boolean) => responseInfoSlices.actions.setErrorShow(errorShow)


export default responseInfoSlices.reducer